// Text for the BaZi result tables — the same wording the original calculator page built, with "-" for an empty list.

type Named<K extends string> = { name: string } & { [P in K]?: string };

const NOTHING = "-";
const join = (parts: string[]) => (parts.length ? parts.join(", ") : NOTHING);

export function formatCombination<K1 extends string, K2 extends string>(
  items: ReadonlyArray<Named<K1 | K2>>,
  first: K1,
  second: K2,
): string {
  return join(items.map((item) => `${item.name} (${item[first]} ${item[second]})`));
}

export function formatCombinationWithElement<K1 extends string, K2 extends string>(
  items: ReadonlyArray<Named<K1 | K2> & { element?: string }>,
  first: K1,
  second: K2,
): string {
  return join(items.map((item) => `${item.name} (${item[first]} ${item[second]}) = ${item.element}`));
}

export function formatThreeCombination(
  items: ReadonlyArray<{ name: string; eb1?: string; eb2?: string; eb3?: string; element?: string }>,
): string {
  return join(items.map((item) => `${item.name} (${item.eb1} ${item.eb2} ${item.eb3}) = ${item.element}`));
}

export function formatSenSha(items: ReadonlyArray<{ name: string; value: string }>): string {
  return join(items.map((item) => `${item.value} (${item.name})`));
}

export const formatGrowStage = (stage: { id: number; name: string }): string => `${stage.id}. ${stage.name}`;

export const formatYiJings = (items: ReadonlyArray<{ id: number; name: string }>): string =>
  items.map((item) => `${item.id}. ${item.name}`).join(", ");
